<template>
    <div v-if="lottery_type == 3 || lottery_type == 4" class="flex">
        <div class="flex1 tr">
            <span class="mr4 fs14" v-for="item in row.zhu_select.split(',')" :class="isChosed(row, 'zhu', item)">{{ item }}</span>
        </div>
        <div class="m1"> - </div>
        <div class="flex1 tl">
            <span class="mr4 fs14" v-for="item in row.ke_select.split(',')" :class="isChosed(row, 'ke', item)">{{ item }}</span>
        </div>
    </div>
    <div v-else class="zc-tag-page" :class="{ 'isLottery': isLottery && row.select.length != 0, 'lottery': row.select.includes( result ) }">
        <span
            v-for="( item, index ) in row.select"
            :key="`betting-${ index }`"
            :class="{ 'noFirstItem': index > 0 ,
            'fontWeight':result === item
            }"
            :style="{ color: result === item? '#BE0B00': '#515a6e' }">
            {{ item }}
        </span>
    </div>
</template>

<script>
    export default {
        props: [ 'row', 'isLottery', 'type', 'result', 'lottery_type' ],
        created () {
            this.row.select = this.row.select ? this.row.select.split( ',' ) : [];
        },
        methods: {
            isChosed(obj, jsNa, nr){
                const _t = this
                let clas = '', rest = '';
                // 判断何时开奖？
                const seled = obj[jsNa + '_select']
                if(obj.status == 50){
                    if(_t.type == 4){
                        rest = obj[jsNa + '_result']                        
                    }else{
                        rest = jsNa == 'zhu' ? obj.half_result : obj.whole_result
                    }
                    if(nr == rest && seled.indexOf(rest) != -1) clas = 'seled'
                }
                return clas
            },
        }
    };
</script>

<style lang="less" scoped>
    .m1{ margin:  0 10px; }
    .seled{ color: #be0b00; font-weight: 600; }
    .zc-tag-page {
        margin: 0 -18px;
        padding: 5px 0;
        &.isLottery{
            background: #EEEEEE; color: #a0a0b4;
        }
        &.lottery {
            background: #fff;
        }
        .noFirstItem {
            margin-left: 8px;
        }
        .fontWeight{
            font-weight: 600;
        }
    }
</style>